"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactId = exports.artifactName = void 0;
exports.artifactName = 'payments-cc-form';
exports.artifactId = "com.wixpress." + exports.artifactName;
//# sourceMappingURL=artifactInfo.js.map